import { IrrComponent } from "@/features";

export const IrrPage = () => {
  return <IrrComponent />;
}